import { COLORS } from "./colors.js";

export const GLOBAL_STYLES = `
/* Hyperlinks brighten to the brand purple on hover. Inline-styled links keep
   their own colour (inline wins over this rule); this covers plain anchors and
   gives every link a consistent hover transition. */
a {
  transition: color 120ms ease;
}
a:hover {
  color: ${COLORS.brandText};
}
@keyframes shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
@keyframes spin {
  to { transform: rotate(360deg); }
}
@keyframes slideInRight {
  from { transform: translateX(100%); }
  to { transform: translateX(0); }
}
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-8px); }
  to { opacity: 1; transform: translateY(0); }
}
`;

export function injectGlobalStyles() {
  if (typeof document === "undefined") return;
  if (document.getElementById("gtm-ui-globals")) return;
  const style = document.createElement("style");
  style.id = "gtm-ui-globals";
  style.textContent = GLOBAL_STYLES;
  document.head.appendChild(style);
}
